import type { DirectiveCallback } from 'alpinejs';

const ResizeObserverDirective: DirectiveCallback = (
  el,
  { expression },
  { evaluateLater, cleanup }
) => {
  const evaluate = evaluateLater(expression);

  const obs = new ResizeObserver(() => evaluate());
  obs.observe(el);

  cleanup(() => obs.disconnect());
};

export default ResizeObserverDirective;
